import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../constants/url';
import axiosApi from '../../api/daonAxios';

const Header = () => {

  const navigate = useNavigate();

  const location = useLocation();

  const [hasUnreadAlarm, setHasUnreadAlarm] = useState(false);

  const fetchUnreadAlarm = async () => {
    try {
        const jToken = localStorage.getItem('jToken');

        const res = await axiosApi.get('/alarm/unread', {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        });

        setHasUnreadAlarm(res.data.result === true);

    } catch (error) {
        console.error('미확인 알림 조회 실패', error);
    }
  };

  useEffect(() => {
      fetchUnreadAlarm();
  }, []);

  useEffect(() => {
      fetchUnreadAlarm();
  }, [location.pathname]);
  
  return (
    <div className="header" tabIndex={0}>
      
      <h1 className="total-title">WellBe</h1>
      
      <div className='set-box'>
          <button className='set-box-alarm' onClick={() => navigate(URL.ALARM)}>
            <span className='blind'>알림설정</span>
            {/* <em></em> */}
            {hasUnreadAlarm && <em />}
          </button>
          <button className='set-box-setting' onClick={() => navigate(URL.APP_SETTINGS)}>
            <span className='blind'>세팅설정</span>
          </button>
      </div>
    </div>
  );
};

export default Header;
